/**
 * Step tags to be used to configure frontend .
 */
export enum StepTag {
  AUTHORISED_MIME_TYPE = 'AUTHORISED_MIME_TYPE',
  INVITE_BUTTON_DISABLE = 'INVITE_BUTTON_DISABLE',
  CONFIGURATOR_WATCHER_SHOW = 'CONFIGURATOR_WATCHER_SHOW'
}
